import _ from 'lodash';
import { ADMIN_PATH, ADMIN_TAB_PATHS } from '../../constants/paths.constants';
import { typeToString } from '../../lib/dossier.utils';
import { offerings } from '../../services/bff.api';

export const ADMIN_OFFERINGS_RESOURCE = {
  key: 'ADMIN_OFFERINGS_RESOURCE',
  detailPath: `${ADMIN_PATH}${ADMIN_TAB_PATHS.OFFERING_DETAIL.path}`,
  table: {
    defaultSort: 'title',
    dataLocation: '_embedded.offerings',
    searchParams: ['title'],
    fields: [
      { value: 'title', label: 'Titel', show: true, order: 0 },
      { value: 'shortDescription', label: 'Korte beschrijving', show: true, order: 1 },
      {
        value: 'dossierType',
        label: 'Dossiertype',
        show: true,
        order: 2
      },
      { value: 'themes', label: 'Label', show: true, blockSort: true, order: 3 }
    ],
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i,
        shortDescription: _.truncate(i.shortDescription, { length: 80 }),
        dossierType: typeToString(i.dossierType),
        themes: i?.themes?.join(', ') ?? ''
      }))
  },
  single: {
    public: true,
    dataTransform: (data) => ({
      ...data,
      image: data?.images?.[0] ?? ''
    }),
    defaultState: {
      title: '',
      shortDescription: '',
      description: '',
      formSlug: '',
      dossierType: '',
      visibleUnauthorized: false,
      visibleSchools: false,
      visiblePartners: false,
      visibleCity: false,
      themes: [],
      images: []
    }
  },
  api: {
    get: offerings.search,
    getById: (id) => offerings.getById(id)
  }
};
